import { Conversation } from 'ha/services/apiV2/types/Conversation';
import { MakeCall } from 'ha/services/apiV2/createMakeCall';
import { APIV2_URL } from './constants';

interface Payload {
  messageText: string;
}

interface Query {
  expand: string;
}

export default (makeCall: MakeCall) =>
  (conversationId: number, data: Payload, query?: Query) =>
    makeCall<Conversation>(
      'PUT',
      `${APIV2_URL}/conversation/${conversationId}/response`,
      { data, query },
    );
